import React, { useState } from 'react';
import { Gestion, JornadaCardProps, GestionInfo } from 'components/Types/GeneralTypes';
import './JornadaCard.scss';
import JustificacionForm from '../Gestion/JustificacionForm';
import { capitalizeFirstLetter, formatDate, getBorderColor } from 'services/justificaciones';
import { format, isAfter, parseISO, isToday } from 'date-fns';
import { es } from 'date-fns/locale';
import RecuperacionForm from '../Gestion/RecuperacionForm';
import { FiClock as Timer , FiFile} from 'react-icons/fi';  // Replaces `Timer`
import EventIcon from '../../Varios/EventIcons';
import { DownloadDocument2 } from 'helpers/files';
import pdf from "./../../../assets/icons/descarga.svg";

function JornadaCard({ jornadaLaboral, tipo, onClose }) {

  const [showFormJustificacion, setShowFormJustificacion] = useState(false);
  const [showFormRecuperacion, setShowFormRecuperacion] = useState(false);
  const { jornada, receso, fechaPlazoSolicitud, fecha } = jornadaLaboral;
  if (tipo === 'C') {

    return (
      <div className={`jornadacard border-warning`}>
        <div className="card-body">
          <h6 className="card-title text-info mb-3">Recordatorio de Recuperación</h6>
          <div className="row g-3">
            <div className="col-md-6">
              <small className="text-info">Fecha del evento:</small>
              <p className="fw-medium mb-0">{jornada.fechaEvento}</p>
            </div>
            <div className="col-md-6">
              <small className="text-info">Correspondiente a:</small>
              <p className="fw-medium mb-0">{jornada.tipoGestion}</p>
            </div>
            <div className="col-md-6">
              <small className="text-info">Fecha de recuperación:</small>
              <p className="fw-medium mb-0">{jornada.fechaRecuperacionStr}</p>
            </div>
            <div className="col-md-6">
              <small className="text-info">Hora a la que debe finalizar su jornada:</small>
              <p className="fw-medium mb-0">{jornada.horaFin}</p>
            </div>
            <div className="col-12">
              <small className="text-info">Mensaje:</small>
              <div
                className="fw-medium text-dark"
                dangerouslySetInnerHTML={{ __html: jornada.mensaje }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
  const fechaplazo = formatDate(fechaPlazoSolicitud);
  const context = tipo === 'L' ? jornada : receso;
  let justificacion: GestionInfo = context.justificacion;
  let recuperacion: GestionInfo = context.recuperacion;
  const borderColor = getBorderColor(context.tipo);
  const diaSemana = capitalizeFirstLetter(format(new Date(fecha), 'EEEE', { locale: es }));
  const lastday = parseISO(fechaPlazoSolicitud);
  const hoy = new Date();
  const isDateValid = isToday(lastday) || isAfter(lastday, hoy);
  const hasAction = (context.gestionJ || context.gestionR) && context.tipo === -1;
  const hasJustification = !!context.justificacion;
  const hasRecovery = !!context.recuperacion;
  const detalleRecuperacion = context.detalleRecuperacion;

  const shouldShowCardBody = hasAction || hasJustification || hasRecovery || !!detalleRecuperacion;
  const iconStyle = { width: '35px', height: '35px' };
  return (
    <div className={`jornadacard border-${borderColor}`}>
      <div className="jornada-layout">
        {/* Parte del Widget (20%) */}
        <div className="widget">
          <div className="widget-title-wrapper">
            <div className={`widget-date-${borderColor}`}>
              <span className="widget-date-day">{format(new Date(fecha), 'dd', { locale: es })}</span>
              <span className="widget-date-month">{format(new Date(fecha), 'MMM', { locale: es })}</span>
            </div>
            <p className="widget-meeting-time">{diaSemana}</p>
          </div>
        </div>

        {/* Contenido Principal (80%) */}
        <div className="jornada-main">
          <div className="jornada-icon">
            <EventIcon tipo={context.tipo} style={iconStyle} />
          </div>
          <div className="card-header">
            <h5 className="card-title">{context.estado}</h5>
          </div>


          {/* Content */}
          <div className="card bg-white mb-4">
            <div className="card-body">
              <div className="row align-items-center">
                <div className="col d-flex align-items-center gap-2">
                  <Timer className="text-secondary" />
                  <div>
                    <small className="text-muted">Hora Inicio</small>
                    <p className="fw-bold mb-0">{context.inicio || "*"}</p>
                  </div>
                </div>
                <div className="col-auto">
                  <div className="vr h-100"></div>
                </div>
                <div className="col d-flex align-items-center gap-2">
                  <Timer className="text-secondary" />
                  <div>
                    <small className="text-muted">Hora Fin</small>
                    <p className="fw-bold mb-0">{context.fin || "*"}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Condiciones adicionales y botones */}
          {shouldShowCardBody && (
            <div className="card-info">
              {hasAction && (
                <div className="correction-container">
                  <p className="card-text text-center">Fecha máxima para ingresar solicitud:  {fechaplazo}. </p>
                </div>)
              }
              {hasJustification && (
                <div className="card bg-grey bg-opacity-10 pb-2">
                  <div className="card-body">
                    <h6 className="card-title text-info mb-3">Información de Justificación</h6>
                    <div className="row g-3">
                      <div className="col-md-6">
                        <small className="text-info">Estado</small>
                        <p className="fw-medium mb-0">{justificacion.estado}</p>
                      </div>
                      <div className="col-md-6">
                        <small className="text-info">Correspondiente a</small>
                        <p className="fw-medium mb-0">{justificacion.tipoGestion}</p>
                      </div>
                      <div className="col-md-6">
                        <small className="text-info">Hora Inicio</small>
                        <p className="fw-medium mb-0">{justificacion.horaInicio}</p>
                      </div>
                      <div className="col-md-6">
                        <small className="text-info">Hora Fin</small>
                        <p className="fw-medium mb-0">{justificacion.horaFin}</p>
                      </div>
                      <div className="col-12">
                        <small className="text-info">Mensaje</small>
                        <div
                          className="fw-medium text-dark"
                          dangerouslySetInnerHTML={{ __html: justificacion.mensaje }}
                        />
                      </div>
                      {justificacion.referenciaa && (
                        <div className="col-12 text-end" style={{ textAlign: "right" ,  cursor: "pointer"}}  role="button"
                        onClick={() => DownloadDocument2(justificacion.referenciaa, "solicitud")}
                        >
                        <img
                         src={pdf}
                         alt="Descargar"
                         className="me-2"
                         style={{ width: "50px", height: "50px" }}

                       />
                        </div>)

                      }
                      
                    </div>
                  </div>
                </div>
              )}
              {hasRecovery && (
                <div className="card bg-grey bg-opacity-10">
                  <div className="card-body">
                    <h6 className="card-title text-info mb-3">Información de Recuperación</h6>
                    <div className="row g-3">
                      <div className="col-md-6">
                        <small className="text-info">Estado</small>
                        <p className="fw-medium mb-0">{recuperacion.estado}</p>
                      </div>
                      <div className="col-md-6">
                        <small className="text-info">Correspondiente a</small>
                        <p className="fw-medium mb-0">{recuperacion.tipoGestion}</p>
                      </div>
                      <div className="col-md-6">
                        <small className="text-info">Fecha Recuperación</small>
                        <p className="fw-medium mb-0">{recuperacion.fechaRecuperacionStr}</p>
                      </div>
                      <div className="col-md-6">
                        <small className="text-info">Hora Fin de Recuperación</small>
                        <p className="fw-medium mb-0">{recuperacion.horaFin}</p>
                      </div>
                      <div className="col-12">
                        <small className="text-info">Mensaje</small>
                        <div
                          className="fw-medium text-dark"
                          dangerouslySetInnerHTML={{ __html: recuperacion.mensaje }}
                        />
                      </div>
                      {recuperacion.referenciaa && (
                        <div className="col-12 text-end" style={{ textAlign: "right" ,  cursor: "pointer"}}  role="button"
                        onClick={() => DownloadDocument2(recuperacion.referenciaa, "solicitud")}
                        >
                        <img
                         src={pdf}
                         alt="Descargar"
                         className="me-2"
                         style={{ width: "50px", height: "50px" }}

                       />
                        </div>)

                      }
                    </div>
                  </div>
                </div>
              )}
              {detalleRecuperacion && (
                <div className="card bg-grey bg-opacity-10">
                  <div className="card-body">
                    <h6 className="card-title text-info mb-3">Información de Recuperación</h6>
                    <div className="row g-3">
                      <div className="col-md-6">
                        <small className="text-info">Estado</small>
                        <p className="fw-medium mb-0">{detalleRecuperacion.estado}</p>
                      </div>
                      <div className="col-md-6">
                        <small className="text-info">Correspondiente a</small>
                        <p className="fw-medium mb-0">{detalleRecuperacion.tipoGestion}</p>
                      </div>
                      <div className="col-md-6">
                        <small className="text-info">Fecha de evento</small>
                        <p className="fw-medium mb-0">{detalleRecuperacion.fechaEvento}</p>
                      </div>
                      <div className="col-md-6">
                        <small className="text-info">Hora Fin de Recuperación</small>
                        <p className="fw-medium mb-0">{detalleRecuperacion.horaFin}</p>
                      </div>
                      <div className="col-12">
                        <small className="text-info">Mensaje</small>
                        <div
                          className="fw-medium text-dark"
                          dangerouslySetInnerHTML={{ __html: detalleRecuperacion.mensaje }}
                        />
                      </div>

                      <div className="col-12 text-end" style={{ textAlign: "right" ,  cursor: "pointer"}}  role="button"
                        onClick={() => DownloadDocument2(detalleRecuperacion.referenciaa, "solicitud")}
                        >
                        <img
                         src={pdf}
                         alt="Descargar"
                         className="me-2"
                         style={{ width: "50px", height: "50px" }}

                       />
                        </div>
                    </div>

                  </div>
                </div>
              )}
              {hasAction && (
                <div className="correction-container">
                  {!isDateValid && (
                    <p className="card-text text-danger text-center">
                      Su plazo para ingresar una solicitud ha caducado.
                    </p>
                  )}
                  {isDateValid && (
                    <div className="action-buttons d-flex justify-content-center">
                      {(context.gestionJ && !hasJustification) && (
                        <button className="btn btn-secondary btn-sm mx-2 " onClick={() => setShowFormJustificacion(true)}>
                          Solicitar Justificación
                        </button>
                      )}
                      {(context.gestionR && !hasRecovery) && (
                        <button className="btn btn-secondary btn-sm mx-2 " onClick={() => setShowFormRecuperacion(true)}>
                          Solicitar Recuperación
                        </button>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      </div>


      <JustificacionForm
        isOpen={showFormJustificacion}
        tipo={tipo}
        jornadaLaboral={jornadaLaboral}
        onAccept={() => {
          setShowFormJustificacion(false);
          onClose();
        }}
        onCancel={() => setShowFormJustificacion(false)}
      />
      <RecuperacionForm
        isOpen={showFormRecuperacion}
        tipo={tipo}
        jornadaLaboral={jornadaLaboral}
        onAccept={() => {
          setShowFormRecuperacion(false);
          onClose();
        }}
        onCancel={() => setShowFormRecuperacion(false)}
      />
    </div>
  );
}

export default React.memo(JornadaCard)